import { gql } from '@apollo/client';

export const GetCourseQuery = gql`
    query GetCourse($id: ID!) {
        getOLCourse(id: $id) {
            id
            name
            certificateUrl
            certificateType
            testAvailable
            passTestForAnyResult
            testsCount
            subjectsCount
            testStatus
            test {
                questionsCount
                duration
                showResultScore
            }
        }
    }
`;
